import React from 'react';
import Select from 'react-select';
import VehicleApi from '../../psuite-js/apis/delivery/vehicle';

class VehicleSelect extends React.Component {
    state = { selectedOption: '', options: [], isLoading: true }

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        const filter = {
            user_id: { $ne: 'None' }
        };

        VehicleApi.all({ include: 'user', filter }).then(result => {
            const options = result.data.data;
            this.setState({ options, isLoading: false });
        }).catch(e => {
            this.setState({ isLoading: false });
        });
    }

    handleChange = (selectedOption) => {
        this.setState({ selectedOption })
    };

    optionRenderer = (option) => {
        const user = option.user || {};

        return (
            <div>
                <div>{user.display_name || '--'}</div>
                <small>{option.id}</small>
            </div>
        );
    }

    valueRenderer(option) {
        const user = option.user || {};
        return `${option.id} (${user.display_name || '--'})`;
    }

    filterOptions(options, filter, currentValues) {
        if (filter) {
            return options.filter(option => {
                const user = option.user || { display_name: '' };
                return (option.id.toLowerCase().includes(filter.toLowerCase()) || user.display_name.toLowerCase().includes(filter.toLowerCase()));
            });
        } else {
            return options;
        }
    }

    render() {
        const { selectedOption } = this.state;
        const value = (selectedOption && selectedOption.id) || this.props.defaultValue;

        return (
            <div>
                <Select
                    className="vehicle_select"
                    name="vehicle"
                    value={value}
                    onChange={this.handleChange}
                    placeholder="Selecione"
                    noResultsText="Nenhum veículo encontrado"
                    isLoading={this.state.isLoading}
                    valueKey="id"
                    labelKey="id"
                    options={this.state.options}
                    optionRenderer={this.optionRenderer.bind(this)}
                    valueRenderer={this.valueRenderer.bind(this)}
                    filterOptions={this.filterOptions.bind(this)}
                />
                <input type="hidden" id="vehicle_id" name="vehicle_id" value={value || ''} />
            </div>
        );
    }
}

export default VehicleSelect;



// WEBPACK FOOTER //
// ./src/components/Select/Vehicle.js